import { SchemaDeSerBuilder } from "./deser"

export class MarketData {
  symbol = ""
  bid = NaN
  ask = NaN
}

export const MARKET_DATA_DESER = new SchemaDeSerBuilder(MarketData)
  .ofString("symbol")
  .ofFloat("bid")
  .ofFloat("ask")
  .toDeSer()
